import React from 'react';
import { useObservable } from 'react-use-observable';

import { Divider, Row, Col } from 'antd';

import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { refundsService } from 'v2/services/reports/refunds';

import { ExportRefunds } from './Export';

export const Details = () => {
  const [totalItems] = useObservable(() => refundsService.getTotalItems(), []);
  const [totalRefunded] = useObservable(() => refundsService.getTotalRefunded(), []);
  const [isLoading] = useObservable(() => refundsService.isLoading(), []);

  const refundsCount = `${totalItems} ${totalItems > 1 ? 'reembolsos' : 'reembolso'}`;

  if (isLoading) return null;

  return (
    <Row
      id='refunds-details'
      className='mb-4 w-full rounded-sm bg-white shadow-[0_1px_0_0_rgba(0,0,0,0.07)]'
      align='middle'
    >
      <Col>
        <div className='px-4 py-2'>
          <span className='text-base font-semibold'>{refundsCount}</span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <Col>
        <div className='px-4 py-2'>
          <span className='text-base font-semibold'>
            Total Reembolsado: <ColoredFormattedNumber value={totalRefunded} format='BRL' />
          </span>
        </div>
      </Col>
      <Divider type='vertical' className='h-10' />
      <PermissionHide action={'myeduzz:reports:exportar'}>
        <Col className='ml-auto'>
          <ExportRefunds />
        </Col>
      </PermissionHide>
    </Row>
  );
};
